import { FC } from "react";
import NextLink, { LinkProps } from "next/link";

interface ILink extends LinkProps {
  children: React.ReactNode;
  href: string;
}

/**
 * LinkComponent is a thin wrapper around the NextLink that allows the storefront
 * to specify useful default for the storefront.
 *
 * @param props {ILink} react props
 * @returns {React.ReactNode} React component.
 */
const LinkComponent: FC<ILink> = (props) => {
  const { children, ...rest } = props;
  return <NextLink {...rest}>{children}</NextLink>;
};

export default LinkComponent;
